<template>
  <div>
    <!--    信息接报-->
    <div id="type1" ref="type1Refs">1</div>
    <div id="type2" ref="type2Refs">2</div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

const val = Math.random() * 100;
const angle = Math.PI * val / 50 / 2;
// 渐变起点
const pointStart = [
  1 - 0.5 * Math.cos(angle) * Math.sin(angle),
  1 + 0.5 * Math.cos(angle) * Math.cos(angle)
];
// 渐变终点
const pointEnd = [
  1 - 0.5 * Math.sin(angle),
  1 + 0.5 * Math.cos(angle)
];
export default {
  name: "type",
  data() {
    return {
      options: {},
      total: 0,
      Type1ChartsDom: null,
      Type2ChartsDom: null,
      colorList: [{
        c1: "#00FFB4",
      },
        {
          c1: "#EA3E3E", //高
        },
        {
          c1: "#FF9000", //正常
        },
        {
          c1: "#e8f383", //危险
        },
        {
          c1: "#287CE8", //危险
        },
        {
          c1: "#6f3eea", //高
        },
        {
          c1: "#63ea3e", //高
        },],
      pointStart,
      pointEnd,
      show: true
    }
  },
  mounted() {
    this.getType1Data()
    this.getType2Data()
  },
  destroyed() {
    this.Type1ChartsDom.dispose()
    this.Type2ChartsDom.dispose()
  },
  methods: {
    initType1Charts() {
      let Type1ChartsDom = document.getElementById('type1')
      this.Type1ChartsDom = echarts.init(Type1ChartsDom)
      this.Type1ChartsDom.setOption(this.options)
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.Type1ChartsDom.resize();
        });
      });
    },
    initType2Charts() {
      let Type2ChartsDom = document.getElementById('type2')
      this.Type2ChartsDom = echarts.init(Type2ChartsDom)
      this.Type2ChartsDom.setOption(this.options)
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.Type2ChartsDom.resize();
        });
      });
    },
    nowSize(val, initWidth = 1920) {
      let nowClientWidth = document.documentElement.clientWidth;
      return val * (nowClientWidth / initWidth);
    },
    getType1Data() {
      let colorList = this.colorList
      let data = []
      this.$http.get(`/api/getEventNumberByType?channel=2`).then(res => {
        if (res.status === 200) {
          let datas = res.data.map((item, index) => {
            return {
              value: item.number,
              name: item.name.toString().length > 4 ? item.name.toString().substring(0, 4) + '...' : item.name,
              c: colorList[index].c1,
            }
          })

          for (let i in datas) {
            if (datas[i].name === '总计') {
              this.total = datas[i].value
            } else {
              data.push(datas[i])
            }
          }
          this.options = {
            title: {},
            graphic: {
              type: 'text',
              left: 'center',
              //left: '37%',
              top: 'center',
              style: {
                text: this.total + '\n' + '总计',
                textAlign: 'center',
                fill: '#fff',
                width: 30,
                height: 30,
                fontSize: '.7rem'
              }
            },
            series: [
              {
                labelLayout: function (params) {
                  const isLeft = params.labelRect.x < document.getElementById('type1').clientWidth / 2;
                  const points = params.labelLinePoints;
                  points[2][0] = isLeft
                    ? params.labelRect.x
                    : params.labelRect.x + params.labelRect.width;
                  return {
                    labelLinePoints: points
                  };
                },
                emphasis: {
                  scale: false,
                },
                label: {
                  // position: 'outer',
                  alignTo: 'edge',
                  edgeDistance: '10%',
                  lineHeight: 14,
                  fontSize: this.nowSize(10),
                  formatter: [
                    '{d}%',
                    '{b}'
                  ].join('\n'),// {b}：数据名；{c}：数据值；{d}：百分比
                },
                labelLine: {
                  showAbove: true,
                  length: 8,
                  length2: 40
                },
                radius: ['58%', '60%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'typePie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  return item;
                }),
              },
              {
                label: {
                  show: false
                },
                radius: ['40%', '55%'],
                emphasis: {
                  scale: false,
                },
                avoidLabelOverlap: false,
                name: 'typePie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: this.colorList[index]
                  };
                  return item;
                }),
                itemStyle: {},
              },
              {
                label: {
                  show: false
                },
                emphasis: {
                  scale: false,
                },
                radius: ['36%', '38%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'typePie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c,
                  };
                  item.itemStyle = {
                    color: item.c,
                  }
                  return item;
                }),

              },
            ]
          }
          this.$nextTick(() => {
            this.initType1Charts()
          })
        }
      })
    },
    getType2Data() {
      let data = []
      this.$http.get(`/api/getEventNumberByStatus?channel=2`).then(res => {
        if (res.status === 200) {
          data = [
            // { value: res.data[0].number, name: '高', c: [ 1, 0, 0, 0 ] },
            {value: res.data[0].handled, name: '已完成', c: '#287CE8'},
            {value: res.data[0].handling, name: '正在处理', c: '#00FFB4'},
            {value: res.data[0].notHandle, name: '未处理', c: '#EA3E3E'},
          ]
          this.total = res.data[0].all
          this.options = {
            title: {},
            graphic: {
              type: 'text',
              left: 'center',
              //left: '37%',
              top: 'center',
              style: {
                text: this.total + '\n' + '总计',
                textAlign: 'center',
                fill: '#fff',
                width: 30,
                height: 30,
                fontSize: '.7rem'
              }
            },
            series: [
              {
                labelLayout: function (params) {
                  const isLeft = params.labelRect.x < document.getElementById('type2').clientWidth / 2;
                  const points = params.labelLinePoints;
                  points[2][0] = isLeft
                    ? params.labelRect.x
                    : params.labelRect.x + params.labelRect.width;
                  return {
                    labelLinePoints: points
                  };
                },
                emphasis: {
                  scale: false,
                },
                label: {
                  // position: 'outer',
                  alignTo: 'edge',
                  edgeDistance: '10%',
                  lineHeight: 14,
                  fontSize: this.nowSize(10),
                  formatter: [
                    '{d}%',
                    '{b}'
                  ].join('\n'),// {b}：数据名；{c}：数据值；{d}：百分比
                },
                labelLine: {
                  showAbove: true,
                  length: 8,
                  length2: 40
                },
                radius: ['58%', '60%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'typePie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c
                  };
                  return item;
                }),
              },
              {
                label: {
                  show: false
                },
                radius: ['40%', '55%'],
                emphasis: {
                  scale: false,
                },
                avoidLabelOverlap: false,
                name: 'typePie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: this.colorList[index]
                  };
                  return item;
                }),
                itemStyle: {},
              },
              {
                label: {
                  show: false
                },
                emphasis: {
                  scale: false,
                },
                radius: ['36%', '38%'],
                // selectedOffset: 0,
                avoidLabelOverlap: false,
                name: 'typePie',
                type: 'pie',
                minAngle: 60,//最小角度
                data: data.map((item, index) => {
                  item.label = {
                    color: item.c,
                  };
                  item.itemStyle = {
                    color: item.c,
                  }
                  return item;
                }),

              },
            ]
          }
          this.$nextTick(() => {
            this.initType2Charts()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
#type1 {
  width: 50%;
  height: 13vh;
  float: left;
}

#type2 {
  width: 50%;
  height: 13vh;
  float: left;
}
</style>
